import type React from "react";

import {
  Tooltip as ToolTipComponent,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "./tooltip";

type TooltipType = {
  children: React.ReactNode;
  content: React.ReactNode;
  side?: "right" | "top" | "bottom" | "left" | undefined;
};

export const TooltipWrapper: React.FC<TooltipType> = ({ children, content, side }) => (
  <TooltipProvider disableHoverableContent>
    <ToolTipComponent>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side}>
        <p>{content}</p>
      </TooltipContent>
    </ToolTipComponent>
  </TooltipProvider>
);
